// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ONBOARDING = '/onboarding';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
    register: path(ROOTS_AUTH, '/register'),
    registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
    setPassword: path(ROOTS_AUTH, '/set-password'),
    verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_ONBOARDING = {
    root: ROOTS_ONBOARDING,
    setup: {
        root: path(ROOTS_ONBOARDING, '/setup'),
        email: path(ROOTS_ONBOARDING, '/setup/email'),
        whatsapp: path(ROOTS_ONBOARDING, '/setup/whatsapp'),
    },
};

export const PATH_PAGE = {
    landingPage: '/landingpage',
    landingPage4: '/landinpage4',
    landingPage5: '/landingpage5',
    comingSoon: '/coming-soon',
    maintenance: '/maintenance',
    pricing: '/pricing',
    payment: '/payment',
    about: '/about-us',
    contact: '/contato',
    contactUs: '/contact-us',
    privacy: '/politica-de-privacidade',
    terms: '/termos-de-uso',
    faqs: '/faqs',
    blog: {
        root: '/blog',
        post: (slug) => `/blog/${slug}`,
    },
    page404: '/404',
    page500: '/500',
    components: '/components',
    companies: {
        root: '/empresas',
        search: '/empresas/busca'
    },
};

export const PATH_DASHBOARD = {
    root: ROOTS_DASHBOARD,
    salesAgent: path(ROOTS_DASHBOARD, '/sales-agent'),
    buyCredits: path(ROOTS_DASHBOARD, '/comprar-creditos'),
    referrals: path(ROOTS_DASHBOARD, '/referrals'),
    whatsapp: {root: path(ROOTS_DASHBOARD, '/whatsapp')},
    general: {
        app: path(ROOTS_DASHBOARD, '/app'),
        ecommerce: path(ROOTS_DASHBOARD, '/ecommerce'),
        analytics: path(ROOTS_DASHBOARD, '/analytics'),
        banking: path(ROOTS_DASHBOARD, '/banking'),
        booking: path(ROOTS_DASHBOARD, '/booking')
    },
    mail: {
        root: path(ROOTS_DASHBOARD, '/mail'),
        all: path(ROOTS_DASHBOARD, '/mail/all')
    },
    chat: {
        root: path(ROOTS_DASHBOARD, '/chat'),
        new: path(ROOTS_DASHBOARD, '/chat/new'),
        conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
    },
    calendar: path(ROOTS_DASHBOARD, '/calendar'),
    leads: {
        root: path(ROOTS_DASHBOARD, '/leads'),
        list: path(ROOTS_DASHBOARD, '/leads/list'),
        editById: path(ROOTS_DASHBOARD, `/leads/id/edit`),
        board: path(ROOTS_DASHBOARD, '/leads/board')
    },
    contacts: {
        root: path(ROOTS_DASHBOARD, '/contacts'),
        cards: path(ROOTS_DASHBOARD, '/contacts/cards'),
        list: path(ROOTS_DASHBOARD, '/contacts/list'),
        newContact: path(ROOTS_DASHBOARD, '/contacts/new'),
        editById: path(ROOTS_DASHBOARD, `/contacts/id/edit`),
    },
    settings: {
        root: path(ROOTS_DASHBOARD, '/user'),
        account: path(ROOTS_DASHBOARD, '/user/account'),
        kanban: path(ROOTS_DASHBOARD, '/config/kanban')
    },
    user: {
        root: path(ROOTS_DASHBOARD, '/user'),
        profile: path(ROOTS_DASHBOARD, '/user/profile'),
        cards: path(ROOTS_DASHBOARD, '/user/cards'),
        list: path(ROOTS_DASHBOARD, '/user/list'),
        newUser: path(ROOTS_DASHBOARD, '/user/new'),
        editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
        account: path(ROOTS_DASHBOARD, '/user/account'),
        icps: path(ROOTS_DASHBOARD, '/user/icps')
    },
    teams: {
        root: path(ROOTS_DASHBOARD, '/teams'),
        list: path(ROOTS_DASHBOARD, '/teams/list'),
        newTeam: path(ROOTS_DASHBOARD, '/teams/new'),
        editById: path(ROOTS_DASHBOARD, `/teams/reece-chung/edit`),
    },
    campaigns: {
        root: path(ROOTS_DASHBOARD, '/campaigns'),
        list: path(ROOTS_DASHBOARD, '/campaigns/list'),
        newCampaign: path(ROOTS_DASHBOARD, '/campaigns/new'),
        guidedSearch: path(ROOTS_DASHBOARD, '/campaigns/guided-search'),
        guidedNew: path(ROOTS_DASHBOARD, '/campaigns/guided-new'),
        guidedNewPt: path(ROOTS_DASHBOARD, '/pesquisas/nova'),
        guidedLegacy: path(ROOTS_DASHBOARD, '/campaigns/guided-legacy'),
        editById: path(ROOTS_DASHBOARD, `/campaigns/reece-chung/edit`),
    },
    eCommerce: {
        root: path(ROOTS_DASHBOARD, '/e-commerce'),
        shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
        product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
        productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
        list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
        newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
        editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
        checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
        invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
    },
    blog: {
        root: path(ROOTS_DASHBOARD, '/blog'),
        posts: path(ROOTS_DASHBOARD, '/blog/posts'),
        post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
        postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
        newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
    },
    /** Natural-language BigQuery assistant (Supabase Edge `cnpj_assistant`). */
    cnpjAssistant: path(ROOTS_DASHBOARD, '/cnpj-assistant'),
    outreachCampaigns: {
        root: path(ROOTS_DASHBOARD, '/outreach-campaigns'),
        list: path(ROOTS_DASHBOARD, '/outreach-campaigns/list'),
        builder: path(ROOTS_DASHBOARD, '/outreach-campaigns/builder'),
        details: (id) => path(ROOTS_DASHBOARD, `/outreach-campaigns/${id}`),
    },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
